import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ResponsiveService } from '@service/responsive.service';
import { OperationsHistoryData } from 'ops/common/models/operations-history-data';

@Component({
    selector: 'app-operation-table-row',
    templateUrl: './operation-table-row.component.html',
    styleUrls: [
        './operation-table-row.component.scss',
        '../alarm-table-row/alarm-table-row.component.scss',
    ],
    standalone: false
})
export class OperationTableRowComponent {
    @Input() operation: OperationsHistoryData;
    @Input() index: number;

    @Output() onShowDetail = new EventEmitter<OperationsHistoryData>();

    protected userNamePrefix = 'ops.operations.history';

    constructor(public responsive: ResponsiveService) {}

    emitShowDetail() {
        this.onShowDetail.emit(this.operation);
    }
}
